import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {GoogleIconComponent} from './google-icon/google-icon.component';

@NgModule({
  declarations: [GoogleIconComponent],
  imports: [CommonModule],
  exports: [GoogleIconComponent]
})
export class GoogleIconModule {
}
